import globalAxios from 'axios';
import { createRequestFunction, DUMMY_BASE_URL, setSearchParams, toPathString } from './common.js';
import { BaseAPI, BASE_PATH } from './base.js';

/* tslint:disable */
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary GET state-api/cart-version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartApiVersion: async (options = {}) => {
            const localVarPath = `/state-api/cart-version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary GET state-api/cart-version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCartApiVersion(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCartApiVersion(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends BaseAPI {
    /**
     *
     * @summary GET state-api/cart-version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCartApiVersion(options) {
        return DefaultApiFp(this.configuration).getCartApiVersion(options).then((request) => request(this.axios, this.basePath));
    }
}

export { DefaultApi, DefaultApiAxiosParamCreator, DefaultApiFp };
//# sourceMappingURL=api.js.map
